import { render, staticRenderFns } from "./ViewV2.vue?vue&type=template&id=5b50edf8&scoped=true"
import script from "./ViewV2.vue?vue&type=script&lang=js"
export * from "./ViewV2.vue?vue&type=script&lang=js"
import style0 from "./ViewV2.vue?vue&type=style&index=0&id=5b50edf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b50edf8",
  null
  
)

export default component.exports